import { Base64 } from "js-base64";
import CallApp from 'callapp-lib';
import { GET_OAUTH_JSSDK_SIGN } from '@/api/config'
import * as $http from "@/api/fetch";
import dayjs from "dayjs";
import ENV from "./env";
window.dayjs = dayjs;
import _this from "@/main";

export function call_app (options){
     new CallApp({
        scheme: {
            protocol:'afd',
        },
        intent: {
            package: "net.afdian.afdian",
            scheme: "afd"
        },
        universal:{ 
          host:'uljump.afdian.net'
        },
        appstore: ENV.appstore,
        yingyongbao: ENV.yingyongbao,
        fallback: ENV.androidstore
     }).open(options)
}
// export const call_app = new CallApp({
//     scheme: {
//       protocol:'afd'
//     },
//     appstore: ENV.appstore,
//     yingyongbao: ENV.yingyongbao,
//     fallback: ENV.androidstore
// });
export function userlink(user, query = {}) {
    if (user && user.url_slug) {
        return { path: `/a/${user.url_slug}`, query };
    }
    return { path: `/u/${user.user_id}`, query };
}

export function php_time_to_js_time(time) {
    if ((time + "").length == 10) {
        time = time * 1000;
    }
    return time;
}

export function is_today(time) {
    let diff = new Date().getTime() - php_time_to_js_time(time);
    return diff < 1000 * 60 * 60 * 24 && diff > 0;
}

export function next_week(time = new Date()) {
    return dayjs(time).add(1, 'week')
}

export function next_month(time = new Date()) {
    return dayjs(time).add(1, 'month')
}

export function time_to_future(future, from = 0, type = '') { //时间戳 毫秒的
  let is_time_over = (dayjs(future) - dayjs(new Date())) < 0
  let now = from > 0 ? dayjs(from) : dayjs(new Date());
  let fur = dayjs(future)
  let day = fur.diff(now, 'day');
  let hour = fur.diff(now, 'hour') % 24;
  let minute = fur.diff(now, 'minute') % 60;
  let second = fur.diff(now, 'second') % 60;
  let second_total = fur.diff(now, 'second');
  let day_str = day > 0 ? day + _this.$t('c.tool.text1') : '';
  let hour_str = hour > 0 ? hour + _this.$t('c.tool.text2') : '';
  let minute_str = minute > 0 ? minute + _this.$t('c.tool.text3') : '';
  let second_str = second > 0 ? second + _this.$t('c.tool.text4') : '';
  
  if(type == 'arr'){
    return {
      day,
      hour: hour < 10 ? `0${hour}` : hour,
      minute: minute < 10 ? `0${minute}` : minute,
      second: second < 10 ? `0${second}` : second,
      second_total,
      day_str,
      hour_str,
      minute_str,
      second_str,
      is_time_over
    }
  }
  return `${day_str}${hour_str}${minute_str}`
}

export function is_array(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]';
}
export function is_unsafe_user(user) {
  if(user){
    if(user.is_not_rec == 1 || user.is_verified == 0){
      return true;
    }
    if(user.creator && (user.creator.status == 3 || user.creator.status == 4)){
      return true;
    }
    if(user.status == 2 || user.status == 3){
      return true;
    }
  }
  return false;
}

export function noindex_metas(user) {
  let arr = [];
  if(ENV.is_crawler && is_unsafe_user(user)){
    arr = [
      {name:'robots', content: 'noindex,nofollow'},
      {name:'googlebot', content: 'noindex,nofollow'},
      {name:'bingbot', content: 'noindex,nofollow'},
      {name:'baiduspider', content: 'noindex,nofollow'},
    ]
  }
  return arr
}

export function from_now(time) {
    let text = "";
    let time_diff = (new Date().getTime() * 1 - time * 1) / 1000;
    if (time_diff <= 10) {
        text = "刚刚";
    } else if (time_diff < 60) {
        text = Math.floor(time_diff) + "秒前";
    } else if (time_diff < 3600) {
        text = Math.floor(time_diff / 60) + "分钟前";
    } else if (time_diff < 86400) {
        text = Math.floor(time_diff / 3600) + "小时前";
    }
    return text;
}

export function duration(time, is_direct = false) {
    //time 单位毫秒
    let text = dayjs(time).subtract(8, 'hour').format("HH:mm:ss"); //貌似是从1970年 8点开始的时间
    if(is_direct){
        return text
    }
    let time_diff = time - 60 * 60 * 1000;
    if (time_diff > 0) {
        text = `${dayjs(time).hour() - 8}:${text}`; //貌似是从1970年 8点开始的时间
    }
    // console.log(text);

    return text;
}

export function img_type(src) {
    let result = {
        is_gif: false,
        src: src,
        crop_src:'',
        w: "",
        h: "",
        is_long: false,
        is_so_long: false,
        is_swiper_top: false,
    };
    if (/\.gif/.test(src)) {
        result.is_gif = true;
        result.src = src.replace(".jpg.gif", ".gif.jpg");
    }

    if (/_w/.test(src)) {
        result.w = src.match(/_w(\d+)/)[1];
    }
    if (/_h/.test(src)) {
        result.h = src.match(/_h(\d+)/)[1];
        result.is_long = result.h / result.w >= 2;
        if(result.h > 2000 && result.is_long){
            result.is_so_long = true;
            result.crop_src = result.src + `?imageMogr2/gravity/NorthWest/crop/375x500`
        }
    }
    if (result.w && result.h) {
        result.is_swiper_top =
            result.h > (window.innerHeight / window.innerWidth) * result.w;
    }
    return result;
}

export function img_src({
    is_show_origin = false,
    src,
    width = 0,
    height = 0,
    type = 1,
    watermark = 1,
    watermark_text = '',
    q = '',
}) {
    if (
        is_show_origin ||
        src.indexOf("imageMogr2") != -1 ||
        src.indexOf("imageView2") != -1 ||
        src.indexOf("blob") != -1
    ) {
        return src;
    }

    let ratio = global.window ? window.devicePixelRatio : 1;
    let size = ratio > 1 ? 2 : 1;
    let w = "";
    let h = "";
    let wm = '';
    let _q = ''
    if (width > 0) {
        w = "/w/" + width * size;
    }
    if (width == "screen") {
        w = "/w/" + document.body.clientWidth * size;
    }

    if (height > 0) {
        h = "/h/" + height * size;
    }
    if (height == "screen") {
        h = "/h/" + document.body.clientHeight * size;
    }
    if(q){
      _q = `/q/${q}`
    }
    if(watermark > 1){ //https://cloud.tencent.com/document/product/460/6951
        let batch = watermark == 3 ? 1 : 0
        wm =`%7Cwatermark/2/text/${Base64.encode('          ' + watermark_text).replace(/\+/g,'-').replace(/\//g,'_')}/fill/IzgzODM4Mw==/fontsize/32/dissolve/40/gravity/southeast/dx/24/dy/24/batch/${batch}/degree/330=`
        // wm = `%7Cwatermark/${watermark}/fontsize/16/text/6IW-6K6v5LqRwrfkuIfosaHkvJjlm74/fill/IzgzODM4Mw==/degree/30%7CimageMogr2/sharpen/150`
    }
    src = src + "?imageView2/" + type + w + h + _q + wm;
    return src;
}

export function debounce(fn, t = 1000) {
    if(debounce.time_out){
        clearTimeout(debounce.time_out);
        debounce.time_out = null;
    }
    debounce.time_out = setTimeout(() => {
        fn()
    },t)
}

export function nl2br(str) {
    var breakTag = "<br>";
    return (str + "").replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        "$1" + breakTag + "$2"
    );
}

export function find_url(str, data_attr) {
    let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-|@|#)+)/g;
    let match_result = str.match(reg);

    if (match_result && match_result.length > 0) {
        match_result.forEach((v, k) => {
            if (v.indexOf("afdian.net") != -1) {
                str = str.replace(v, `<a class="purple" ${data_attr} href="${v}">${v}</a>`);
            }
        });
    }
    return str;
}

export function params(obj, is_need_base64) {
    let arr = [];
    for (let key in obj) {
      let v = obj[key];
      if (is_need_base64) {
          arr.push(`${key}=${Base64.encode(v)}`);
      } else {
        if(Object.prototype.toString.call(v) == '[object Object]' || Object.prototype.toString.call(v) == '[object Array]'){
          v = JSON.stringify(v)
          arr.push(`${key}=${v}`);
        }else{
          arr.push(`${key}=${encodeURIComponent(v)}`);
        }
      }
    }
    return arr.join("&");
}
export function safe_substr(str, start = 0, end = 0) { //防止emoji等字符串分割出问题
  return Array.from(str).slice(start, end).join('')
}

export function get_img_base64(img) {
    // img.crossOrigin = "Anonymous";
    let canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.width, img.height);
    // let ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
    let dataURL = canvas.toDataURL("image/png");
    return dataURL;
}

export function img2base64(node_pre, bg_img_url) { //node_pre: img || 含有：background-image的node
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.crossOrigin = "Anonymous";
        if(node_pre.nodeName == 'IMG' && !bg_img_url){
          image.onload = () => {
            let base64 = get_img_base64(image);
            node_pre.src = base64;
            resolve();
          };
          image.src = node_pre.src;
        }
        if(bg_img_url){
          image.onload = () => {
            let base64 = get_img_base64(image);
            node_pre.style.backgroundImage = `url(${base64})`;
            resolve();
          };
          image.src = bg_img_url;
        }
    });
}

export function time_show(time, format = "YYYY-MM-DD", no_today = false) {
    var time = php_time_to_js_time(time);
    if (!no_today && is_today(time)) {
        return from_now(time);
    }
    return dayjs(time).format(format);
}

export function get_url_query(name) {
    let query_list = location.search.replace("?", "").split("&");
    let result = "";
    if (query_list.length > 0) {
        query_list.forEach((v, k) => {
            let arr = v.split("=");
            if (arr[0] == name) {
                result = arr[1];
            }
        });
    }
    return result;
}

export function sign_url(str, is_blank = true) {
    // let reg = /((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/g
    let reg = /(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_=@]*)?/g;
    let target = is_blank ? 'target="_blank"' : "";
    let jump = ENV.is_afd_client ? 'onclick="return false"' : ''
    return str.replace(
        reg,
        (m) =>
            `<a class="purple" ${jump} ${target} href="${
                m.indexOf("afdian.net") == -1
                    ? "https://afdian.net/link?target=" + escape(m)
                    : m
            }">${m}</a>`
    );
}

export function escapeHTML(a) {
    a = "" + a;
    return a.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function remove_html_tag(html) {
    return html.replace(/<[^>]+>/g, "");
}

export function file_size(size) {
    let re = size / 1024 / 1024;
    return re > 1 ? parseInt(re) + "M" : parseInt(size / 1024) + "K";
}
export function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export function openLocation(data) {
  if(ENV.is_wechat){
    wx.openLocation({
      latitude: data.latitude, // 纬度，浮点数，范围为90 ~ -90  
      longitude: data.longitude, // 经度，浮点数，范围为180 ~ -180。 
      name: data.name, // 位置名
      address: data.address, // 地址详情说明
      scale: data.scale || 1, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: data.infoUrl || '' // 在查看位置界面底部显示的超链接,可点击跳转
    });
    return false;
  }
  if(ENV.is_mobile){
    location.href = data.baidu_url
    return false;
  }
  window.open(data.baidu_url)
}

export function load_paypay_fraudnet2_config(options) { //https://developer.paypal.com/limited-release/fraudnet/integrate/
  let script = document.getElementById('fconfig');
  if (script) {
      if (script.parentNode) {
          script.parentNode.removeChild(script);
      }
  }
  script = document.createElement('script');    
  script.id = 'fconfig';
  script.type = 'application/json';
  script.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
  let cmid = uuidv4();
  let configuration = {
      'f': cmid,
      's': options.s, //unique for each web page
      // 'ts': {
      //     "type": "UL",
      //     "fields": [{"id":"email", "min":8}, {"id":"password", "min":8}],
      //     "delegate": false
      // }
  };
  script.text = JSON.stringify(configuration);
  document.body.appendChild(script);
  let fnUrl = "https://c.paypal.com/da/r/fb.js";
  _loadBeaconJS();
         
  function _loadBeaconJS() {
      let script = document.createElement('script');
      script.src = fnUrl;
      document.body.appendChild(script);
  }
  return cmid
}

export function app_download() {
    let url = ENV.is_ios ? ENV.appstore : ENV.androidstore
         // : "https://www.coolapk.com/apk/250011";
          //   'https://android.myapp.com/myapp/detail.htm?apkName=net.afdian.afdian';
          //   'https://www.pgyer.com/afdian';
        //   "http://app.mi.com/details?id=net.afdian.afdian";
    if(ENV.is_huawei){
        url = 'https://appgallery.cloud.huawei.com/ag/n/app/C101439207'
    }
    location.href = url;
}
export function app_version(v) {
    //不传v 返回当前版本号
    //传v，返回 所在版本和参数版本比较 'lower'  'same'  'higher'
    let arr = navigator.userAgent.match(/afdian\/(.*)\/webview/);
    let ver = arr && arr.length > 0 ? arr[1] : "";
    if (!v) {
        return ver;
    }
    let re = "same";
    let arr_local = ver.split(".").map(v => v*1);
    let arr_target = v.split(".").map(v => v*1);
    if (arr_local.length < 3) {
        //旧版本只有一位
        return "lower";
    }

    if (arr_local[0] > arr_target[1]) {
        re = "higher";
    } else if (arr_local[0] < arr_target[0]) {
        re = "lower";
    } else {
        if (arr_local[1] > arr_target[1]) {
            re = "higher";
        } else if (arr_local[1] < arr_target[1]) {
            re = "lower";
        } else {
            if (arr_local[2] > arr_target[2]) {
                re = "higher";
            } else if (arr_local[2] < arr_target[2]) {
                re = "lower";
            }
        }
    }
    return re;
}

export function escape_html(str) {
  return str.replace(/[&<>"'\/]/g, function (s) {
      var entityMap = {
          "&": "&",
          //   '&': '&amp;',
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
          //   '/': '&#x2F;'
          "/": "/",
      };

      return entityMap[s];
  });
}

export function unescape_html(str) {
  if(str.length === 0){
    return ''
  }
  return str.replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&nbsp;/g,' ').replace(/&#39;/g,`'`).replace(/&quot;/g,`"`).replace(/&rdquo;/g,`"`)
}

export function is_bundle_plan(plan = {}) {
  return plan.product_type == 2 || plan.product_type == 3
}


export function download_file(url, filename = "") {
    const getBlob = (url) => {
        return new Promise((resolve) => {
            const xhr = new XMLHttpRequest();

            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                }
            };

            xhr.send();
        });
    };

    const saveAs = (blob, filename) => {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement("a");
            const body = document.querySelector("body");

            link.href = window.URL.createObjectURL(blob); // 创建对象url
            link.download = filename;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);

            window.URL.revokeObjectURL(link.href); // 通过调用 URL.createObjectURL() 创建的 URL 对象
        }
    };

    getBlob(url).then((blob) => {
        saveAs(blob, filename);
    });
}

function load_wx_sdk(){
    return new Promise((resolve, reject) => {
        if(window.wx){
            resolve()
            return false
        }
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = 'async'
        s.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
        document.body.appendChild(s);
        s.onload = () =>{
            resolve(wx)
        }
    })
}
function wx_config_sign(url) {
    return new Promise(async (resolve, reject) => {
        let data = await $http.$axios(GET_OAUTH_JSSDK_SIGN, {
            url,
        });
        if (data.ec != 200) {
          this.$notify({
            title: data.em,
            group: 'error',
          });
          reject()
          return false;
        }
        resolve(data.data)
        // let d = data.data;
    })

}
export function wx_share(data){
    if(!data.pic){
        data.pic = 'https://static.afdiancdn.com/static/img/logo/logo.png'
    }
    if (wx.updateAppMessageShareData) { //“分享给朋友”及“分享到QQ”
        wx.updateAppMessageShareData({
            title: data.title,
            desc: data.description,
            link: data.url,
            imgUrl: data.pic,
            success: function() {}
        });
    } else {
        wx.onMenuShareAppMessage({
            title: data.title, // 分享标题
            desc: data.description, // 分享描述
            link: data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data.pic, // 分享图标
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {}
        });
    }
    if (wx.updateTimelineShareData) {//“分享到朋友圈”及“分享到QQ空间”
         wx.updateTimelineShareData({
            title: data.title,
            link: data.url,
            imgUrl: data.pic,
            success: function() {}
        });
    } else {
        wx.onMenuShareTimeline({
            title: data.title,
            link: data.url,
            imgUrl: data.pic,
            success: function() {}
        });
    }
    if(wx.onMenuShareQQ){
        wx.onMenuShareQQ({
            title: data.title, // 分享标题
            desc: data.description, // 分享描述
            link: data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data.pic, // 分享图标
            success: function () {},
            cancel: function () {}
        });
    }
    if(wx.onMenuShareQZone){
        wx.onMenuShareQZone({
            title: data.title, // 分享标题
            desc: data.description, // 分享描述
            link: data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data.pic, // 分享图标
            success: function () {},
            cancel: function () {}
        });
    }
}
export function wx_jssdk_ready(url, fn = function(){}){
    Promise.all([load_wx_sdk(), wx_config_sign(url)]).then((result) => {
        let d = result[1]
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: d.appId, // 必填，公众号的唯一标识
            timestamp: d.timestamp, // 必填，生成签名的时间戳
            nonceStr:  d.nonceStr, // 必填，生成签名的随机串
            signature:  d.signature,// 必填，签名
            openTagList:['wx-open-launch-app'],
            jsApiList: [ //https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#63
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'onMenuShareQQ',
                'onMenuShareQZone',
                'menuItem:share:appMessage',
                'menuItem:share:timeline',
                'menuItem:share:qq',
                'menuItem:share:QZone',
                'menuItem:favorite',
                'wx-open-launch-app',
                'getLocation',
                'openLocation',
            ] // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
            fn()
        });
    }).catch((error) => {
        console.log(error)
    })
}

export function get_scroll_offset(){
  if (window.pageXOffset) {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    }
  } 
  return {
    x: document.body.scrollLeft || document.documentElement.scrollLeft,
    y: document.body.scrollTop || document.documentElement.scrollTop
  }
}
export function encode_uri_express(uri){
  if(uri.indexOf('顺丰') == -1){
    uri = uri.replace(/&mobile=(\d+)/,'')
  }
  return encodeURI(uri)
}

// function load_wx_login_sdk(){
//     return new Promise((resolve, reject) => {
//         if(window.WxLogin){
//             resolve()
//             return false
//         }
//         const s = document.createElement('script');
//         s.type = 'text/javascript';
//         s.async = 'async'
//         s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
//         document.body.appendChild(s);
//         s.onload = () =>{
//             resolve()
//         }
//     })
// }
// export function wx_login_ready(fn){
//     Promise.all([load_wx_login_sdk()]).then((result) => {
//         fn()
//     })
// }
